module.exports = __webpack_public_path__ + "static/media/aceshades-4.4df2643f.png";